// extracted by mini-css-extract-plugin
export default {"link":"styles_link__qdB-U","icons":"styles_icons__S+Tg8","invisibleText":"styles_invisibleText__eGqHq"};